import { AppContext } from './../app/app-context.enum';
export const environment = {
  production: true,
  appContext: AppContext.Editor
};
